import { Route } from '@angular/router';
import { AuthGuard } from '@fsf/auth';
import { MenuItem } from 'primeng/api';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ImprintPageComponent } from './pages/imprint-page/imprint-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'locations/list',
    pathMatch: 'full',
  },
  {
    path: 'login',
    title: 'eliso IQ - Login',
    component: LoginPageComponent,
    data: {
      breadcrumbs: [{ label: 'Login' }] as MenuItem[],
    },
  },
  {
    path: 'forgot-password',
    title: 'eliso IQ - Forgot Password',
    component: ForgotPasswordComponent,
    data: {
      breadcrumbs: [{ label: 'Forgot Password' }] as MenuItem[],
    },
  },
  {
    path: 'reset-password/:hash',
    title: 'eliso IQ - Reset Password',
    component: ResetPasswordComponent,
    data: {
      breadcrumbs: [{ label: 'Reset Password' }] as MenuItem[],
    },
  },
  {
    path: 'change-password',
    title: 'eliso IQ - Change Password',
    component: ResetPasswordComponent,
    data: {
      breadcrumbs: [{ label: 'Change Password' }] as MenuItem[],
    },
  },
  {
    path: 'set-password/:hash',
    title: 'eliso IQ - Set Password',
    component: ResetPasswordComponent,
    data: {
      breadcrumbs: [{ label: 'Set Password' }] as MenuItem[],
    },
  },
  {
    path: 'imprint',
    title: 'eliso IQ - Imprint',
    component: ImprintPageComponent,
    data: {
      breadcrumbs: [{ label: 'Imprint' }] as MenuItem[],
    },
  },
  {
    path: 'analysis',
    title: 'eliso IQ - Analysis',
    loadComponent: () =>
      import('./pages/dashboard-page/dashboard-page.component').then(
        (c) => c.DashboardPageComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      breadcrumbs: [{ label: 'Analysis' }] as MenuItem[],
    },
  },
  {
    path: 'location/:id',
    title: 'eliso IQ - Location Dashboard',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/dashboard-page/dashboard-page.component').then(
        (c) => c.DashboardPageComponent,
      ),
    data: {
      breadcrumbs: [
        { label: 'Locations', routerLink: '/locations/list' },
        { label: 'Location Dashboard' /*, icon: 'fa-regular fa-chart-bar' */ },
      ] as MenuItem[],
    },
  },
  {
    path: 'locations',
    //canActivate: [AuthGuard],
    children: [
      {
        path: 'list',
        title: 'eliso IQ - Locations',
        loadComponent: () =>
          import(
            './pages/location-list-page/location-list-page.component'
          ).then((c) => c.LocationListPageComponent),
        data: {
          breadcrumbs: [{ label: 'Locations' }] as MenuItem[],
        },
      },
      {
        path: 'map',
        title: 'eliso IQ - Search Map',
        loadComponent: () =>
          import('./pages/location-map-page/location-map-page.component').then(
            (c) => c.LocationMapPageComponent,
          ),
        data: {
          breadcrumbs: [
            // { label: 'Locations', routerLink: ['..', 'list'] },
            { label: 'Search Map' },
          ] as MenuItem[],
        },
      },
    ],
  },
  {
    path: 'scoring-schema',
    title: 'eliso IQ - Scoring Schema',
    //canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/scoring-schema-page/scoring-schema-page.component').then(
        (c) => c.ScoringSchemaPageComponent,
      ),
    data: {
      breadcrumbs: [{ label: 'Scoring Schema' }] as MenuItem[],
    },
  },
  {
    path: '**',
    title: 'eliso IQ',
    redirectTo: 'login',
  },
];
